/*
 * @Author: Lemon C
 * @Date: 2024-05-13 12:06:31
 * @LastEditTime: 2025-03-11 09:36:01
 */
import { ElLoading } from 'element-plus';
import 'element-plus/theme-chalk/index.css';


let loadingInstance;

function showLoading() {
    loadingInstance = ElLoading.service({
        lock: true,
        background: 'rgba(0, 0, 0, 0.0)'
    });
}

function hideLoading() {
    loadingInstance.close();
}


export { showLoading, hideLoading };